export default "__VITE_ASSET__50bf7316__"